<div class="px-5 pt-5 pb-8 overflow-y-auto">

    @if(!labSubmissionDetails || labSubmissionDetails?.labManTypesId === 1) {
        <app-lab-soft-tissue-results-table></app-lab-soft-tissue-results-table>
    } @else {
        <app-lab-soil-results-table></app-lab-soil-results-table>
    }

    <div class="flex flex-col items-start mt-4">
        <mat-checkbox *ngIf="canApprove && labSubmissionDetails.labManStatusId !== 6" class="mb-5" (ngModelChange)="emitCorrectResults.emit($event)" [(ngModel)]="resultsAreCorrect">I hereby declare that lab results are correct.</mat-checkbox>

        <div class="flex items-center mb-1.5">
            <span class="font-bold text-[14px] w-[164px]">Approved By:</span>
            <span class="text-[13px]">{{ labSubmissionDetails?.approvedByName && labSubmissionDetails?.approvedBySurname ? labSubmissionDetails?.approvedByName + ' ' + labSubmissionDetails?.approvedBySurname : '-' }}</span>
        </div>

        <div class="flex items-center mb-1.5">
            <span class="font-bold text-[14px] w-[164px]">Date Approved:</span>
            <span class="text-[13px]">{{ labSubmissionDetails?.dateApproved ? (labSubmissionDetails.dateApproved | date: 'yyyy-MM-dd, hh:mm:ss') : '-' }}</span>
        </div>
    </div>

    <div class="h-px bg-[var(--app-base)] my-6"></div>

    <span class="text-[16px] font-bold text-[var(--base-text-alt-dark)]">Attachments</span>

    <div class="mt-5 mb-4">
        <button (click)="openAttachFileDialog()"
            class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
            <span class="material-icons text-[16px]">attach_file</span> ATTACH FILE
        </button>
    </div>

    <div class="flex items-center justify-between bg-[#F5F5F5] h-[52px] px-5 rounded-lg mt-2.5 text-[12px]" *ngFor="let attachment of attachments">
        <div class="flex items-center">
            <span class="font-bold mr-2.5">Date Uploaded:</span>
            <span>{{ attachment.dateModified | date: 'yyyy-MM-dd, hh:mm:ss' }}</span>
            <div class="border-l border-[#C8C8D2] h-[23px] mx-5"></div>
            <span class="font-bold mr-2.5">Description:</span>
            <span>{{ attachment.description }}</span>
        </div>

        <div class="flex items-center gap-3">
            <div (click)="removeLabResultAttachment(attachment?.id)" class="h-8 w-8 cursor-pointer rounded flex items-center justify-center bg-[var(--notification-error)]">
                <span class="material-icons text-[18px] text-white">delete</span>
            </div>
            <div (click)="editLabResultAttachment(attachment)" class="h-8 w-8 cursor-pointer rounded flex items-center justify-center bg-[var(--primary-dark)]">
                <span class="material-icons text-[18px] text-white">edit</span>
            </div>
            <div (click)="downloadLabResultAttachment(attachment)" class="h-8 w-8 cursor-pointer rounded flex items-center justify-center bg-[#63B6E6]">
                <span class="material-icons text-[18px] text-white">visibility</span>
            </div>
        </div>
    </div>

</div>
